"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-env browser */
const AbstractRandomGenerator_1 = __importDefault(require("./AbstractRandomGenerator"));
// cryptographically strong PRNGs available in modern browsers
class BrowserRandomGenerator extends AbstractRandomGenerator_1.default {
    /**
     * @name Random.fraction
     * @summary Return a number between 0 and 1, like `Math.random`.
     * @locus Anywhere
     * @return {Number}
     */
    // eslint-disable-next-line class-methods-use-this
    fraction() {
        const array = new Uint32Array(1);
        window.crypto.getRandomValues(array);
        return array[0] * 2.3283064365386963e-10; // 2^-32
    }
}
exports.default = BrowserRandomGenerator;
